import { KeyboardSensorID } from "../../sensors/KeyboardSensorID";
import { SensorID } from "../../sensors/SensorID";
import { Arrays } from "../../tools/Arrays";

export class AppCommandBinding
{
  inputs:SensorID[];

  static from( sensorID:SensorID, ...sensorIDs:SensorID[])
  {
    let binding = new AppCommandBinding();

    if ( ! sensorIDs )
    {
      binding.inputs = [ sensorID ];
    }
    else
    {
      binding.inputs = [ sensorID ].concat( sensorIDs );
    }    
    
    return binding;
  }

  static fromAll( sensorIDs:SensorID[] )
  {
    let binding = new AppCommandBinding();
    binding.inputs = sensorIDs;
    return binding;
  }

  static primaryWith( sensorID:SensorID, ...sensorIDs:SensorID[])
  {
    return this.fromAll( Arrays.combine2( KeyboardSensorID.PrimaryModifier, sensorID, sensorIDs ) );
  }

  static secondaryWith( sensorID:SensorID, ...sensorIDs:SensorID[])
  {
    return this.fromAll( Arrays.combine2( KeyboardSensorID.SecondModifier, sensorID, sensorIDs ) );
  }

  static shiftWith( sensorID:SensorID, ...sensorIDs:SensorID[])
  {
    return this.fromAll( Arrays.combine2( KeyboardSensorID.Shift, sensorID, sensorIDs ) );
  }

  static controlWith( sensorID:SensorID, ...sensorIDs:SensorID[])
  {
    return this.fromAll( Arrays.combine2( KeyboardSensorID.Control, sensorID, sensorIDs ) );
  }

  static altWith( sensorID:SensorID, ...sensorIDs:SensorID[])
  {
    return this.fromAll( Arrays.combine2( KeyboardSensorID.Alt, sensorID, sensorIDs ) );
  }
}